import React, { useEffect, useState, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Box, Skeleton, Typography } from '@mui/material';
import { BarChart } from '../../../shared';
import { CONVERSION_BAR_CHART_OPTIONS } from './constants';
import { customCategories } from '../../../../utility';

const ConversionChart = () => {
    const { company } = useSelector((state) => state.company) || {};
    const { dtcData } = useSelector((state) => state.webMatrix);
    const { isWebMatrixPatientLoading, conversionRateBarChart } = dtcData;
    const { categories,data } = conversionRateBarChart;
    const updatedCategories = customCategories(categories);
    const barChartOptions = useMemo(() => ({
        ...CONVERSION_BAR_CHART_OPTIONS,
        xaxis: {
            ...CONVERSION_BAR_CHART_OPTIONS.xaxis,
            categories: updatedCategories
        },
        plotOptions: {
            ...CONVERSION_BAR_CHART_OPTIONS.plotOptions,
            bar: {
                ...CONVERSION_BAR_CHART_OPTIONS.plotOptions.bar,
                columnWidth: updatedCategories.length > 10 ? '40%' : '50px'
            }
        }
    }), [categories]);

    const [key, setKey] = useState(0);

    useEffect(() => {
        setKey((prevKey) => prevKey + 1);
    }, [company]);

    return (
        <Box className="container-p-24-br-16 bg-gray-50 height-100">
            <Box>
                <Typography className="text-md-medium gray-900">
                    Conversion Rate
                </Typography>
                <Typography className="text-sm-regular gray-500" sx={{ marginTop: '4px' }}>
                    * Rate of clicks converted into prescription
                </Typography>
            </Box>
            <Box className="wh-100" id="engagement-deciles">
                {/* Uncomment if you plan to use the loading state */}
                {isWebMatrixPatientLoading ? (
                    <Skeleton height={400} variant="rectangular" width="100%" />
                ) : (
                    <BarChart
                        chartOptions={barChartOptions}
                        chartSeries={[{ name: 'Cost', data: data }]}
                        height={'300px'}
                        key={key}
                    />
                )}
            </Box>
        </Box>
    );
};

export default ConversionChart;
